import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { modulesConfig } from '../constants/modulesConfig';
import { generalReducerValues } from '../General.reducer';

/**
 * для обеспечения показа толко разрешенных модулей модулей
 * @returns showModule:boolean
 */

export const useModulePermissions = () => {
    const { currentModule, user } = useSelector(generalReducerValues);
    const [showModule, setShowModule] = useState(false);

    useEffect(() => {
        if (user?.permissions && currentModule) {
            const currentModulePermissions =
                modulesConfig.find((item) => item.module_name === currentModule)?.permissions || [];
            if (currentModulePermissions.every((item) => user.permissions.includes(item))) {
                setShowModule(() => true);
            }
        }
    }, [currentModule, user?.permissions]);

    return showModule;
};
